import { render, staticRenderFns } from "./carriers-e-app-platforms.vue?vue&type=template&id=6f95866b&scoped=true&"
import script from "./carriers-e-app-platforms.vue?vue&type=script&lang=js&"
export * from "./carriers-e-app-platforms.vue?vue&type=script&lang=js&"
import style0 from "./carriers-e-app-platforms.vue?vue&type=style&index=0&id=6f95866b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f95866b",
  null
  
)

export default component.exports